import Config from '../config.js'
import { createRequestOptions } from './utils';
import { get } from 'lodash';

export default () => {
  return Object.freeze({
    getSubscriptionData: async(userId, appId) => {
      const options = createRequestOptions({ userId, appId });

      const result = await fetch(Config.serverUrl + '/GetSubscriptionData', options);
      const response = await result.json();

      return get(response, 'response');
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/subscriptions.js